import { Result, Spin } from 'antd';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { apiClient } from '@/api/client';

import { clearDevIdentity, isDevLoginEnabled } from './devLogin';
import { invalidateSession } from './useSession';

/**
 * Logs the user out. In Dev Login mode clears the picked identity and returns to the
 * role picker. For all BFF sessions (Entra + ISAM) POSTs to /auth/logout, clears the
 * server session + cookie, then navigates to the IdP's logout page.
 */
export function LogoutPage() {
  const navigate = useNavigate();
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (isDevLoginEnabled()) {
      clearDevIdentity();
      // Same invalidation the real logout path below does. Without it the
      // outgoing identity's /me stays cached for the life of the document, so
      // signing back in as someone else keeps answering as the previous user
      // (advisor-profile prefill being the visible symptom).
      invalidateSession();
      // Dev Login: land the user back on the identity picker so they
      // can immediately sign in as a different role instead of the
      // "You have successfully logged out" dead-end.
      navigate('/auth/dev-login', { replace: true });
      return;
    }

    invalidateSession();
    apiClient
      .post<{ logoutUrl: string }>('/auth/logout', null, {
        baseURL: '/',
      })
      .then(() => {
        navigate('/auth/logged-out', { replace: true });
      })
      .catch((err: unknown) => {
        setError(err instanceof Error ? err.message : 'Logout failed.');
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (error) {
    return <Result status="error" title="Sign-out failed" subTitle={error} />;
  }

  return (
    <div style={{ display: 'flex', justifyContent: 'center', padding: 48 }}>
      <Spin size="large" />
    </div>
  );
}
